import React from 'react'
import * as Styled from './Author.styles'

const Author = ({ publishDate, firstName, lastName, authorLink }) => (
  <Styled.Author>
    <a className="name" href={authorLink}>
      {firstName} {lastName}
    </a>
    <div className="date-and-readtime">
      <span className="publish-date">{publishDate}</span>
      {/* <span className="readtime">&nbsp; &bull; &lt; &nbsp;5 min read</span> */}
    </div>
  </Styled.Author>
)

export default Author
